import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

/**
 * Sonner Toaster con branding Gruppo Impresa Suite (v1.5.0 · 21/07/2026).
 *
 * Personalizzazione per stato:
 *   - success → sfondo verde brand (--gis-green), testo bianco, icona bianca
 *   - error   → sfondo rosso brand (--gis-red), testo bianco
 *   - warning → sfondo oro brand (--gis-gold-50 con bordo oro-dark)
 *   - info    → default shadcn (bg-background)
 *
 * L'aspetto è coerente con bottoni, tab attivi e header dialoghi.
 */
const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group gis-body"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-[var(--gis-green)] group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success:
            "group-[.toaster]:!bg-[var(--gis-green)] group-[.toaster]:!text-white group-[.toaster]:!border-[var(--gis-green-dark)] [&_[data-icon]]:!text-white [&_[data-description]]:!text-white/90",
          error:
            "group-[.toaster]:!bg-[var(--gis-red)] group-[.toaster]:!text-white group-[.toaster]:!border-[var(--gis-red-hover)] [&_[data-icon]]:!text-white [&_[data-description]]:!text-white/90",
          warning:
            "group-[.toaster]:!bg-[var(--gis-gold-50)] group-[.toaster]:!text-[var(--gis-gold-dark)] group-[.toaster]:!border-[var(--gis-gold)] [&_[data-icon]]:!text-[var(--gis-gold-dark)]",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }

